import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
} from 'antd';
import { sortBy } from 'lodash';
import React, { Component } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import BookingApi from '../../functions/api/booking/BookingApi';
import TransferMoneyApi, {
  REASONS,
  STATUS,
  TYPES,
} from '../../functions/api/booking/TransferMoneyApi';
import UserApi from '../../functions/api/user/UserApi';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

class FormMoneyTransferRequest extends Component {
  constructor(props) {
    super(props);

    const userInfo = reactLocalStorage.getObject('user.info');
    this.state = {
      listBooking: [],
      listUsers: [],
      isDisableReason: true,
      reasons: [],
      creator: userInfo.user_acc_full_name,
      isDisableStatus: false,
      typeId: null,
    };
  }
  formRef = React.createRef();

  componentDidMount = async () => {
    const listUsers = await UserApi.getUserByRole('2,3');
    this.setState({
      listUsers: listUsers,
    });

    if (this.props.match.path === '/transfer-requests/add') {
      this.formRef.current.setFieldsValue({
        status: 1,
      });
      this.setState({
        isDisableStatus: true,
      });
    }
  };

  onChangeSelectType = async (event) => {
    const { typeId } = this.state;
    if (typeId !== event) {
      this.formRef.current.setFieldsValue({
        reason_id: null,
      });
    }
    if (event) {
      const typeId = event;
      const reasonByType = REASONS.filter((r) => r.type_id === typeId);
      this.setState({ isDisableReason: false, reasons: reasonByType });
    }

    this.setState({
      typeId: event,
    });
  };

  handleSearch = async (code) => {
    if (!code || code.length < 3) {
      return;
    }
    const listBookingFilter = await BookingApi.searchByCode(code);
    this.setState({
      listBooking: listBookingFilter,
    });
  };

  submitForm = async (values) => {
    const { creator } = this.state;
    let moneyTransferData = {
      ...values,
      creator: creator,
    };

    try {
      const result = await TransferMoneyApi.create(moneyTransferData);
      return result;
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const {
      listBooking,
      listUsers,
      isDisableReason,
      reasons,
      isDisableStatus,
    } = this.state;

    return (
      <>
        <h1>Yêu cầu chuyển khoản</h1>
        <Form
          {...formItemLayout}
          onFinish={this.submitForm}
          name="control-ref"
          ref={this.formRef}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name={['book_code']}
                label="Mã booking"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  onSearch={this.handleSearch}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(listBooking, ['book_code']).map((b) => ({
                    value: b.book_id,
                    label: `${b.book_code}, ${b.cstm_name} ${b.cstm_emai}`,
                  }))}
                  allowClear={true}
                  placeholder="Nhập mã booking-Ít nhất 3 kí tự"
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['reason']}
                label="Lí do chuyển khoản"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['amount']}
                label="Số tiền chuyển đi"
                rules={[{ required: true }]}
              >
                <InputNumber
                  formatter={(value) =>
                    value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                  }
                  className="w-100 text-right"
                  parser={(value) => value.replace(/ /g, '')}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['recipient_account']}
                label="Tài khoản nhận"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['transfer_content']}
                label="Nội dung chuyển khoản"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['type_id']}
                label="Loại"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(TYPES, ['type_name']).map((t) => ({
                    value: t.type_id,
                    label: t.type_name,
                  }))}
                  onChange={this.onChangeSelectType}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['reason_id']}
                label="Mục đích"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(reasons, ['reason_name']).map((r) => ({
                    value: r.reason_id,
                    label: r.reason_name,
                  }))}
                  disabled={isDisableReason}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name={['user_in_charge']} label="User phụ trách">
                <Select allowClear>
                  {sortBy(listUsers, ['user_acc_name']).map((o) => (
                    <Select.Option key={o.user_acc_id} value={o.user_acc_id}>
                      {o.user_acc_full_name || o.user_acc_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['status']}
                label="Trạng thái"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(STATUS, ['status_name']).map((s) => ({
                    value: s.status_id,
                    label: s.status_name,
                  }))}
                  disabled={isDisableStatus}
                />
              </Form.Item>
            </Col>
          </Row>
          <Space>
            <Button htmlType="submit" type="primary">
              Tạo chuyển khoản
            </Button>
          </Space>
        </Form>
      </>
    );
  }
}

export default FormMoneyTransferRequest;
